export function isMostlyPersian(text) {
  const persianCount = (text.match(/[\u0600-\u06FF]/g) || []).length;
  const englishCount = (text.match(/[a-zA-Z]/g) || []).length;

  return persianCount > englishCount;
}
